module.exports = __webpack_public_path__ + "e8037191cabd826153402227b419035e.jpg";